import { useState, useCallback, useEffect } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { apiUrl } from '../utils/apiBase';
const API_BASE = apiUrl('/api/users');

export const useUserManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const authenticatedFetch = useAuthenticatedFetch();

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      const res = await authenticatedFetch(API_BASE);
      if (!res.ok) throw new Error('Errore caricamento utenze');
      const data = await res.json();
      setUsers(data.users || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [authenticatedFetch]);

  const createUser = useCallback(async (u) => {
    try {
      const res = await authenticatedFetch(API_BASE, {
        method: 'POST',
        body: JSON.stringify(u)
      });
      if (!res.ok) throw new Error('Errore creazione utente');
      const data = await res.json();
      setUsers(prev => [...prev, data.user]);
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, [authenticatedFetch]);

  const updateUser = useCallback(async (id, updates) => {
    try {
      const res = await authenticatedFetch(`${API_BASE}/${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates)
      });
      if (!res.ok) throw new Error('Errore aggiornamento utente');
      const data = await res.json();
      setUsers(prev => prev.map(u => u.id === id ? data.user : u));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, [authenticatedFetch]);

  const deleteUser = useCallback(async (id) => {
    try {
      const res = await authenticatedFetch(`${API_BASE}/${id}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Errore eliminazione utente');
      setUsers(prev => prev.filter(u => u.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, [authenticatedFetch]);

  useEffect(() => { loadUsers(); }, []);

  return { users, loading, error, loadUsers, createUser, updateUser, deleteUser, clearError: () => setError(null) };
};
